<template>
  <section class="special_course padding_top">
    <b-container>
      <b-row class="justify-content-center">
        <b-col xl="5">

          <!-- show title if have title slot tempalte -->
          <div class="section_tittle">
            <slot name="title"/>
          </div>
          <!-- End title -->
        </b-col>
      </b-row>

      <!-- show posts if posts not empty -->
      <b-row v-if="getPosts != null">
        <b-col lg="4" sm="6" class="mt-3" v-for="post in getPosts" :key="post.id">
          <m-c11 :img="post.thumbnail">
            <template #p1>
              <router-link class="text-decoration-none p-1"
                           :to="{ name: 'SinglePost', params: { slug: post.slug } }"
              ><h3 class="text-dark h4">{{ post.title }}</h3></router-link>

            </template>

            <template #p2>
              <m-p class="mr-2">نویسنده: {{ `${post.author.name} ${post.author.last_name}` }}</m-p>

            </template>

            <template #p3>
              <div class="text-center">
                <m-a :href="{ name: 'SinglePost', params: { slug: post.slug } }">
                  <m-bt1>ادامه مطلب</m-bt1>
                </m-a>
              </div>
            </template>

          </m-c11>
        </b-col>
      </b-row>
      <!-- end show posts -->

      <!-- show pagination or more button -->
      <b-row>
        <m-pagination-400 v-if="havePagination" :meta="paginationMeta" :on-change-page="changePage"/>

        <slot name="more"/>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import router from "@/router";
import {mapGetters} from "vuex";

export default {
  name: "PostCard",
  props: ["showNumber", "havePagination"],
  computed: {
    ...mapGetters({
      paginationMeta: "Content/getPaginationMeta",
      posts: "Content/getContents",
    }),
    getPosts() {
      if (this.showNumber) {
        const posts = this.posts;
        return posts.slice(0, this.showNumber)
      } else {
        return this.posts
      }
    }
  },
  methods: {
    changePage(page) {
      const form = {
        type: "post",
        page: page,
      };
      this.$store.dispatch("Content/getContents", form);
      router.push({
        name: "Posts",
        query: {...router.currentRoute.query, page: page},
      });
    },
    dateConverter(date) {
      return dateConverter(date, "/");
    },
  },
  async mounted() {
    const form = {
      type: 'post',
      page: 1
    };
    await this.$store.dispatch('Content/getContents', form)
  }
};
</script>

<style scoped>
.card {
  height: 100%;
}
</style>